import { headerBgSize } from './HeaderBgStore';

export const updateHeaderBgSize = (value) => headerBgSize.update(oldValue => value);
